import React from 'react';
import { AppMode } from '../../redux/AppModeState/AppModeState.types';
import { HiddenHeaderWrapper } from './styled';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { getString } from '../../constants/Strings';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { getPaymentServerErrorText } from '../PaymentForm/helpers';
import { PaymentFormDataFields } from '../UserAddress/constants';
export var HiddenHeader = function HiddenHeader(_ref) {
  var mode = _ref.mode;
  var config = useAppSelector(configSelector);
  var paymentErrorModal = config.paymentErrorModal;
  var announcementText;
  switch (mode) {
    case AppMode.ADD:
      announcementText = getPaymentServerErrorText(paymentErrorModal, PaymentFormDataFields.ADD_HIDDEN_HEADER) || getString('APP.HIDDEN.HEADER.ADD');
      break;
    case AppMode.DEFAULT_MOP:
      announcementText = getPaymentServerErrorText(paymentErrorModal, PaymentFormDataFields.DEFAULT_HIDDEN_HEADER) || getString('APP.HIDDEN.HEADER.DEFAULT');
      break;
    case AppMode.LIST_MOPS:
      announcementText = getPaymentServerErrorText(paymentErrorModal, PaymentFormDataFields.LIST_HIDDEN_HEADER) || getString('APP.HIDDEN.HEADER.LIST');
      break;
    case AppMode.EDIT:
      announcementText = getPaymentServerErrorText(paymentErrorModal, PaymentFormDataFields.EDIT_HIDDEN_HEADER) || getString('APP.HIDDEN.HEADER.EDIT');
      break;
    default:
      announcementText = '';
  }
  return /*#__PURE__*/React.createElement(HiddenHeaderWrapper, {
    "data-test": DataTestAttributes.VISUALLY_HIDDEN_HEADER
  }, announcementText);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/HiddenHeader/index.js
// module id = 1507
// module chunks = 11